<template>
  <div
    style="display: block; position: fixed; left: 0px; width: 100vw; z-index: 1"
    :style="{
      'max-height': displayBreakpoint === 'isMobile' ? '40vh' : '20vh',
      bottom: displayBreakpoint === 'isMobile' ? '50px' : '20px'
    }"
    v-if="orders.length > 0"
  >
    <div
      style="
        display: flex;
        flex-wrap: wrap;
        justify-self: center;
        max-height: inherit;
        width: 100%;
      "
      :class="$gStyle('bg-white')"
      class="sticky-banner"
    >
      <div
        style="
          flex-grow: 2;
          display: flex;
          flex-direction: column;
          padding-left: 2%;
          align-self: center;
          max-height: inherit;
          max-width: 100%;
        "
        :class="$gStyle('ml-2')"
      >
        <!-- SparePart Names and Count -->
        <div style="font-size: var('--copytext-font-size-smaller')">
          {{ t('banner.text', { count: orders.length }) }}
        </div>
        <div
          style="
            font-weight: bold;
            max-height: inherit;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: initial;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
          "
        >
          {{ getItemNamesUnique() }}
        </div>
      </div>
      <!-- SparePart Stock and Price  -->
      <div
        style="
          display: flex;
          flex-direction: column;
          max-width: fit-content;
          align-self: center;
          text-align: center;
        "
        :class="$gStyle('mx-2')"
      >
        <div
          :style="{
            color: getColor(getSummaryStockType().value),
            display: 'none'
          }"
        >
          {{ getSummaryStockText().value }}
        </div>
        <div v-if="enablePrices" style="font-weight: bold; hyphens: none">
          {{ getSum() }}
        </div>
      </div>
      <!-- Buttons -->
      <div
        style="display: flex"
        :style="{ flexBasis: displayBreakpoint === 'isMobile' ? '100%' : '' }"
      >
        <patternlib-button
          :loading="isLoading"
          :label="t('banner.showModal')"
          size="S"
          style="max-width: fit-content; align-self: center"
          :style="{ minWidth: displayBreakpoint === 'isMobile' ? '100%' : '' }"
          @click="emit('showCustomerFormModal')"
        ></patternlib-button>
        <div
          v-if="displayBreakpoint !== 'isMobile'"
          style="
            max-width: fit-content;
            min-width: 180px;
            align-self: center;
            justify-content: center;
          "
        >
          <patternlib-link-v2
            :label="t('banner.delete')"
            size="S"
            variant="cross"
            :hide-icon="true"
            :class="$gStyle('mx-4')"
            @click="clearOrders()"
            style=""
          ></patternlib-link-v2>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { isLoading } from '../axios.global';
  import { useOrderStore } from '../stores/order';

  const displayBreakpoint: Ref<string, string> | undefined =
    inject('displayBreakpoint');
  const enablePrices = inject<boolean>('enablePrices');

  const emit = defineEmits(['showCustomerFormModal']);

  const orderStore = useOrderStore();
  const { orders } = storeToRefs(orderStore);
  const {
    getSum,
    getSummaryStockType,
    getSummaryStockText,
    clearOrders,
    getItemNamesUnique
  } = orderStore;

  import { defineEmits, inject, type Ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { getColor } from '../helper/color';
  const { t } = useI18n();
</script>

<style scoped>
  .sticky-banner {
    box-shadow:
      0 -5px 5px -5px #888,
      0 0 1px #888;
  }
  .sticky-banner > * {
    flex-grow: 1;
    flex-basis: auto;
    padding: 5px;
    flex: 1 1 0;
  }
</style>
